import React, { useEffect, useState } from "react";
import InfoIcon from "../../../../assets/icons/info";
import useObjectInput from "../../../../hooks/useObjectInput";
import "./index.css";

// shows node related rules and dependencies
const GOIRulesSection = ({ data }) => {
  const { findErrorObjectById, highlightData, reqResponse, setId } =
    useObjectInput();
  const [dependencyState, setDependencyState] = useState();

  const errorObject = findErrorObjectById(highlightData?.uniqueId);

  const ruleErrorStyle = { backgroundColor: "#9814ac", color: "white" };
  const errorSummaryStyle = { backgroundColor: "#9814ac", width: "140px" };
  const errorClassStyle = {
    background: "#9814ac",
    color: "white",
    fontWeight: "500",
  };

  const Rules = ({ rules }) => (
    <>
      {rules.map((rule, index) => (
        <div
          className="goi-header-rules-section-wrapper-inner"
          id={data.id}
          key={index}
        >
          <p
            id={data.id}
            style={
              errorObject.name === rule.name &&
              data.id === errorObject?.errorAtObjectId
                ? ruleErrorStyle
                : {}
            }
          >
            {rule.name}{" "}
          </p>
          <div className="goi-rules-section-tooltip">
            <InfoIcon />
            <span
              className="goi-rules-section-tooltiptext"
              style={
                errorObject.name === rule.description &&
                data.id === errorObject?.errorAtObjectId
                  ? ruleErrorStyle
                  : {}
              }
            >
              {rule.description}
            </span>
          </div>
        </div>
      ))}
    </>
  );

  const findMatchingObject = (dataObj, parentIdObj) => {
    let found = [];
    for (let key in parentIdObj) {
      const matching = parentIdObj[key];
      matching.filter((obj) => {
        if (dataObj.id === key) {
          found.push(obj);
          return obj;
        }
        return null;
      });
    }
    return reqResponse.data
      .filter((obj) => found.some((parent) => parent.id === obj.id))
      .map((obj) => ({
        ...obj,
        ruleType: found.find((parent) => parent.id === obj.id).type,
      }));
  };

  const matchingAttributeRule = data.rules.attributeRules.find((rule) => {
    const errorObject = findErrorObjectById(highlightData.uniqueId);

    return (
      errorObject &&
      errorObject.name === rule.name &&
      data.id === errorObject.errorAtObjectId
    );
  });

  const matchingClassRule = data.rules.classRules.find((rule) => {
    const errorObject = findErrorObjectById(highlightData.uniqueId);

    return (
      errorObject &&
      errorObject.hint === rule.hint &&
      data.id === errorObject.errorAtObjectId
    );
  });

  const handleActiveObject = (e) => {
    setId(e.target.id);
  };

  useEffect(() => {
    if (reqResponse && data) {
      setDependencyState(
        findMatchingObject(data, reqResponse.parentDependenciesPair)
      );
    }
    // eslint-disable-next-line
  }, [data, reqResponse]);

  return (
    <div className="goi-header-rules-section-wrapper">
      <details>
        <summary style={matchingClassRule ? errorSummaryStyle : {}}>
          Class Rules
        </summary>
        <Rules rules={data.rules.classRules} />
      </details>

      <details>
        <summary style={matchingAttributeRule ? errorSummaryStyle : {}}>
          Attribute Rules
        </summary>
        <Rules rules={data.rules.attributeRules} />
      </details>

      <details>
        <summary
          style={
            highlightData.dependenciesId.includes(data.id)
              ? errorSummaryStyle
              : {}
          }
        >
          As Dependency
        </summary>
        <div className="as-dependency-wrapper">
          {dependencyState?.map((st, index) => (
            <div className="as-dependency-rules" key={index}>
              <span
                id={st.id}
                className="as-dependency-rules-active-object"
                onClick={handleActiveObject}
              >
                <b
                  style={
                    st.id === highlightData.objectId
                      ? { background: "red" }
                      : {}
                  }
                  id={st.id}
                >
                  {st.name}
                </b>
                :
              </span>

              <span>
                {st.ruleType === "class"
                  ? st.rules.classRules.map((rl, index) => {
                      return (
                        <div className="as-dependency-nested" key={index}>
                          <span
                            style={
                              st.id === highlightData.objectId
                                ? errorClassStyle
                                : {}
                            }
                          >
                            {rl.name}
                          </span>
                          <div className="goi-rules-section-tooltip">
                            <InfoIcon />
                            <span className="goi-rules-section-tooltiptext">
                              {rl.description}
                            </span>
                          </div>
                        </div>
                      );
                    })
                  : st.rules.attributeRules.map((rl, index) => {
                      return (
                        <div className="as-dependency-nested" key={index}>
                          <span
                            style={
                              st.id === highlightData.objectId
                                ? errorClassStyle
                                : {}
                            }
                          >
                            {rl.name}
                          </span>
                          <div className="goi-rules-section-tooltip">
                            <InfoIcon />
                            <span className="goi-rules-section-tooltiptext">
                              {rl.description}
                            </span>
                          </div>
                        </div>
                      );
                    })}
              </span>
            </div>
          ))}
        </div>
      </details>
    </div>
  );
};

export default GOIRulesSection;
